import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dc-dashboard',
    templateUrl: './dc-dashboard.component.html',
    styleUrls: ['./dc-dashboard.component.scss'],
    standalone: false
})
export class DcDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
